import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PropertyProviderCategoryModel } from '../models/property-provider-category.model';
import { ConfigService } from '../services/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PropertyProviderCategoryService {

  constructor(private http: HttpClient, private config: ConfigService) { }

  public GetProviderCategory(id: string): Observable<PropertyProviderCategoryModel> {
    return this.http.get<PropertyProviderCategoryModel>(this.config.getApiRoute('api/v3/client-portal/property-provider-categories/' + id)).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }

  public SaveProviderCategory(model: PropertyProviderCategoryModel): Observable<PropertyProviderCategoryModel> {
    return this.http.put<PropertyProviderCategoryModel>(this.config.getApiRoute('api/v3/client-portal/property-provider-categories/' + model.id), model).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }
}
